import {GAMIFICATION_ENDPOINTS} from '../utils/endpoints'
import { makeAPIRequest} from '../utils/request'
import { AppConfigRes } from './config.types'

/**
 * Fetch config for whole app
 */
export const getAppConfig = async (buildNumber: number | null): Promise<AppConfigRes | null> => {
  //defaulting to web for now
  let qParams: any = {
      deviceType: 'ios'
  }
  if(buildNumber) {
      qParams['buildNumber'] = buildNumber
  }
const response = await makeAPIRequest(GAMIFICATION_ENDPOINTS.GET_CONFIG, {
  method: 'GET',
  apiVersion: '2',
  queryParams: qParams
})
if (!response?.data) return null
return response?.data
}
